var _circle, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExclusiveRewards = function SvgExclusiveRewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "var(--color-circle)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.439 7.5H12.093c-.555 0-1.088.22-1.48.61-.393.39-.613.92-.613 1.473v20.834a2.062 2.062 0 0 0 1.074 1.82 2.127 2.127 0 0 0 2.12-.042l6.209-3.806a.685.685 0 0 1 .725 0l6.209 3.805a2.072 2.072 0 0 0 2.12 0 2.074 2.074 0 0 0 1.074-1.819V9.542a2.079 2.079 0 0 0-.627-1.447 2.097 2.097 0 0 0-1.465-.595Zm.697 22.917a.706.706 0 0 1-.363.61.686.686 0 0 1-.697 0l-6.208-3.805a2.268 2.268 0 0 0-1.102-.278 2.268 2.268 0 0 0-1.102.306l-6.209 3.805a.686.686 0 0 1-.697 0 .71.71 0 0 1-.363-.61V9.61a.693.693 0 0 1 .698-.694h15.346a.699.699 0 0 1 .697.694v20.806Z",
    fill: "url(#ExclusiveRewards_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.746 15.14-2.58-.376-1.145-2.32a1.39 1.39 0 0 0-1.255-.783 1.4 1.4 0 0 0-1.256.784l-1.144 2.32-2.58.374a1.398 1.398 0 0 0-1.13.945 1.383 1.383 0 0 0 .362 1.389l1.855 1.819-.432 2.555a1.383 1.383 0 0 0 .544 1.39 1.4 1.4 0 0 0 1.479.11l2.302-1.208 2.302 1.209a1.4 1.4 0 0 0 .655.166c.297-.003.586-.1.823-.278a1.389 1.389 0 0 0 .544-1.389l-.432-2.555 1.855-1.806a1.387 1.387 0 0 0 .363-1.389 1.389 1.389 0 0 0-1.13-.958Zm-2.065 3.18a1.389 1.389 0 0 0-.404 1.236l.446 2.555-2.302-1.208a1.4 1.4 0 0 0-.655-.167 1.4 1.4 0 0 0-.656.167l-2.302 1.208.446-2.555a1.383 1.383 0 0 0-.404-1.236l-1.87-1.806 2.581-.375a1.398 1.398 0 0 0 1.047-.764l1.158-2.32 1.158 2.32a1.391 1.391 0 0 0 1.046.764l2.58.375-1.869 1.806Z",
    fill: "url(#ExclusiveRewards_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ExclusiveRewards_svg__a",
    x1: 10,
    y1: 20,
    x2: 29.531,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ExclusiveRewards_svg__b",
    x1: 13.597,
    y1: 17.588,
    x2: 25.934,
    y2: 17.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })))));
};

export default SvgExclusiveRewards;